<!-- 快手看板 广告组 表格 -->
<template>
	<div class="table-box" >
		<!-- 表头 -->
		<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
			<div class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell"
				:style="{'width':30 + 'px'}">
					<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"></a-checkbox>
				</div>
				<div class="table-th-cell"
				:style="{'width':rableTitle[0].width + 'px'}" style="cursor: default;" 
				@click="sortClick(0)">
					{{rableTitle[0].title}}
				</div>
				
				<div class="table-th-cell" style="cursor: default;"
				:style="{'width':rableTitle[1].width + 'px'}" 
				@click="sortClick(2)">
					{{rableTitle[1].title}}
				</div>
				
			</div>
			
			<div  v-for="(item,index) in rableTitle" :key="index" >
	
				<div v-if="index > sticky_index && item.show_control" class="table-th-cell" 
				:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
				@click="sortClick(index)">
					{{item.title}}
					<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
						<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
						<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
					</div>
				</div>
			</div>
			<!-- 占位，隔出一个空白区域 -->
			<div id="" style="padding:15px;"></div>
		</div>
		
		<!-- 总计 -->
		<div v-if="tableShowData.length > 0" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<!-- 选择 -->
				<div class="table-td-cell" :style="{'width':30 + 'px'}"></div>
				
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_ndex <= sticky_index && z_ndex == 0" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						总计
					</div>
					<div v-else-if="z_ndex <= sticky_index" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						
					</div>
				</template>
			</div>
			
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.show_control && z_table_control.indexOf(z_tem.type) < 0 && c_table_control.indexOf(z_tem.type) < 0" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{tableSumData[z_tem.type] | tableToFixed}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
				
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && c_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{tableSumData[z_tem.type]*100 | tableToFixed}}%
				</div>
			</template>
			
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<!-- 选择 -->
				<div class="table-td-cell" :style="{'width':30 + 'px'}">
					<a-checkbox :checked="item.checked" @change="onChangeCheckbox($event,index)"></a-checkbox>
				</div>
				<div  @click='operation(1,item)' class="table-td-cell"
				:style="{'width':rableTitle[0].width + 'px'}" style="color: #2F88FF;cursor: pointer;">
					{{item[rableTitle[0].type]}}
				</div>

				<div  class="table-td-cell" style="display: flex;align-items: center;"
				:style="{'width':rableTitle[1].width + 'px'}">
					<!-- <a-switch size="small" :checked="item.status_checked" default-checked @change="onStatusCheckbox($event,item)"  checked-children="启用" un-checked-children="暂停"/> -->
					
					<a-popover :visible="item.popover_clicked" @visibleChange="handleClickChange($event,item)" trigger="click" placement="bottom">
						<template slot="content">
						  <div>
							  <!-- <div @click="zhOperation(1,item)" class='cz-button-calss'>编辑</div> -->
							  <!-- <div @click="zhOperation(2,item)" class='cz-button-calss'>同步计划</div> -->
							  <div @click="zhOperation(3,item)" class='cz-button-calss'>查看广告组</div>
						  </div>
						</template>
						
						<a-icon style="font-size: 18px;font-weight: bold;cursor: pointer;margin-left: 7px;" type="more" />
					</a-popover>
					
				</div>
			</div>
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.show_control && c_table_control.indexOf(z_tem.type) < 0 && n_table_control.indexOf(z_tem.type) < 0 && f_table_control.indexOf(z_tem.type) < 0" 
				class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] | tableToFixed}}
				</div>
				<!-- 计划状态 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'status'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] | statusFilters}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'put_status'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] | putStatusFilters}}
				</div>
				<!-- <div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'day_budget'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div> -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'campaign_type'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] | campaignTypeFilters}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'dsp_version'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] | dspVersionFilters}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'create_channel'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] | createChannelFilters}}
				</div>
				
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && c_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]*100 | tableToFixed}}%
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && n_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
				<!-- 投手 -->
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'admin_list'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					<div v-if="item.admin_list.length > 0" style="display: flex;align-items: center;flex-wrap: wrap;">
						<div v-for="(item,index) in item.admin_list" :key="index" style="margin: 0 10px 5px 0;">
							{{item.admin_name}}
						</div>
					</div>
				</div>
			</template>
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
		
	</div>
</template>

<script>
export default {
	name: 'KSggzTable',
	props: ['rableTitle','tableShowData','tableSumData','table_scroll_width','indeterminate','checkAll','table_null_width'],
	data(){
		return {
			select_sort_index: "", // 筛选的
			
			popover_clicked: false,
			
			sticky_index: 1,
			
			// 用于总计的不显示控制
			z_table_control: ['put_status','status','day_budget','campaign_type','dsp_version','create_channel','advertiser_id','campaign_id','create_time','admin_list'],
			
			// 表格项要进行百分比展示的
			c_table_control: ['eff_roi','eff_roi_first','photo_click_ratio','action_ratio','play_3s_ratio'],
			// 表格内容项，不要处理可以直接展示的
			n_table_control: ['day_budget','show','photo_click','aclick','bclick','activation','event_pay_first_day','user_click','eff_total_order_cnt','eff_total_pay_user_cnt','eff_report_pay_user_cnt','advertiser_id','campaign_id','create_time'],
			// 表格项会有单独处理的项，比如要过滤的，要进行额外处理、展示的
			f_table_control: ['put_status','status','campaign_type','dsp_version','create_channel','admin_list'],
		}
	},
	methods: {
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			console.log(that.rableTitle[index].type)
			if(that.rableTitle[index].sort_control){ // 是否有排序功能
				if(index !== this.select_sort_index){
					this.select_sort_index = index
					that.rableTitle.forEach(res=>{
						res.sort_status = 0
					})
					that.rableTitle[index].sort_status = 1
					th_status = 1
				}
				else { // 点击的是同一个表头
					if(that.rableTitle[index].sort_status === 0){
						that.rableTitle[index].sort_status = 1 // 箭头向下
						th_status = 1
					}
					else if(that.rableTitle[index].sort_status === 1){
						that.rableTitle[index].sort_status = 2 // 箭头向上
						th_status = 2
					}
					else if(that.rableTitle[index].sort_status === 2){
						that.rableTitle[index].sort_status = 0
						th_status = 0
					}
				}
				
				
				
				this.$emit('table-th-click', index, th_status, that.rableTitle[index].type)
			}
		},
		// editTable(index){
		// 	this.$emit('edit-td-click', index)
		// },
		TDmouseenter(index){
			// console.log(index);
		},
		// 操作
		operation(e,item){
			// console.log(e,item)
			if(e == 1){ // 点击账户名称
				// 这里使用params方式传参，而不用query是因为，params的参数不会拼在url后面，这样子刷新页面后，传过来的参数就可以自动清空
				this.$router.push({name: 'KSggz_',params: {jump_id: item.campaign_id}})
			}
			else if(e == 2){ // 点击负责人
				this.$emit('click-Fzr', item)
			}
			
		},
		handleClickChange(e,item){
			console.log(e)
			item.popover_clicked = e
		},
		// 表格内的操作项
		zhOperation(e,item){
			// console.log(item);
			if(e == 1){ // 编辑
				item.popover_clicked = false
				// this.$emit('sync-zhxx-click', item)
			}
			else if(e == 2){ // 同步计划
				item.popover_clicked = false
				this.$emit('sync-zhxx-click', item, 2)
			}
			else if(e == 3){ // 查看广告组
				this.$router.push({name: 'KSggz_',params: {jump_id: item.campaign_id}})
			}
		},
		
		// 全选
		onCheckAllChange(e){
			this.$emit('click-All-Checkbox', e)
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			this.$emit('click-Checkbox', checkedList,index)
		},
		
		// 操作项的开关
		onStatusCheckbox(e,item){ // 启用或暂停
			// console.log(e,item);
			this.$emit('status-Checkbox', e, item)
		}
	},
	filters: {
		tableToFixed(value){ // 保留小数点后两位，四舍五入
			// console.log("过滤器",value)
			if(value){
				let v = Number(value)
				return v.toFixed(2)
			}
			else {
				return 0
			}
			
		},
		statusFilters(value){
			// console.log("过滤器",value)
			let vvv 
			if(value == 1){
				vvv = "广告计划已暂停"
			}
			else if(value == 3){
				vvv = "广告计划超预算"
			}
			else if(value == 4){
				vvv = "有效"
			}
			else if(value == 5){
				vvv = "广告计划已删除"
			}
			else if(value == 6){
				vvv = "账户余额不足"
			}
			else if(value == -2){
				vvv = "不限"
			}
			else {
				vvv = "其他"
			}
			
			return vvv
		},
		putStatusFilters(value){
			let vvv
			if(value == 1){
				vvv = "投放中"
			}
			else if(value == 2){
				vvv = "暂停"
			}
			else if(value == 3){
				vvv = "删除"
			}
			else {
				vvv = "其他"
			}
			
			return vvv
		},
		campaignTypeFilters(value){
			let vvv
			if(value == 1){ 
				vvv = "作品推广"
			}
			else if(value == 2){
				vvv = "应用下载"
			}
			else if(value == 3){
				vvv = "获取电商下单"
			}
			else if(value == 4){
				vvv = "推广品牌活动"
			}
			else if(value == 5){
				vvv = "收集营销线索"
			}
			else if(value == 6){
				vvv = "保量广告"
			}
			else if(value == 7){
				vvv = "应用拉活"
			}
			else if(value == 16){
				vvv = "粉丝直播推广"
			}
			else {
				vvv = "其他"
			}
			
			return vvv
		},
		dspVersionFilters(value){
			let vvv
			if(value == 0){
				vvv = "创编2.0"
			}
			else if(value == 3){
				vvv = "创编3.0"
			}
			else {
				vvv = "其他"
			}
			
			return vvv
		},
		createChannelFilters(value){
			let vvv
			if(value == 0){
				vvv = "投放后台创建"
			}
			else if(value == 1){
				vvv = "Marketing API 创建"
			}
			else {
				vvv = "其他"
			}
			
			return vvv
		},
	}
}
</script>

<style scoped>
.cz-button-calss {
	font-size: 13px;
	padding:10px;
	cursor: pointer;
	min-width: 85px;
}
.cz-button-calss:hover {
	background-color: #f4f7fa;
}

/* 表格样式-非公共/基础样式 */
.table-th-cell {
	height: 59px;
}
.table-th-cell:hover {
	background-color: #eee;
}
.table-th-cell:hover .table-th-cell-sticky{
	background-color: #eee;
}

.table-td-cell {
	font-size: 12px;
}
</style>